<div class="row col-12 p-0 m-0 main-page-section ">
  <div class="col-12 p-0 employee-section">
    <div class="col-height">

      <div class="breadcrumbs-section pl-2 ml-5">
        <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
        <img src="../../assets/images/seperator.png">
        <span class="curr-page pl-2 breadcrumbs-section-font current">Companies</span>
      </div>

      <div class="company-layout">
        <div class="row">
          <div class="col-10">
            <h1>Companies</h1>
          </div>
          <!-- <div class="col-2">
            <button routerLink="/company/add-company">Add Company</button>
          </div> -->
        </div>

        <div class="row mt-4 mb-3">
          <div class="col-2">
            <div class="dropdown-border pointer-link" style="position: relative;">
              <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                [ngbPopover]="popContentBuildingName" triggers="manual" #p="ngbPopover"
                (click)="openPopover(p);enterName('buildingName')" (blur)="enterName('buildingName')" placement="bottom"
                popoverClass='dash-popover dashboard-popover'>
                <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
                  [placeholder]="!buildingName ? 'Building Name' : ''" readonly
                  [ngModel]="selectedBuidling|dropdownTextLimiter:selectedBuidling:buildings"
                  (ngModelChange)="selectedBuidling=$event" required>
                <label class="form-lable-dropdown">Building Name</label>
                <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
              </div>
            </div>

            <ng-template #popContentBuildingName>
              <div class="dashboard-popover">
                <div class="d-flex justify-content-between">
                  <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;">
                    <div class="row pb-2 no-wrap-flex" *ngFor="let item of buildings;let index =i"
                      (click)="setBuildingName(item, 'click'); openPopover(p)" style="justify-content: space-between;">
                      <div class="popover-content normal-font pl-3 email-width word-wrap">
                        {{item.parkBuildingName}}
                      </div>
                      <div style="margin-right: 10px;" *ngIf="item.checked">
                        <img src="assets/images/company/tick.png">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>

          <div class="col-2">
            <div class="dropdown-border pointer-link" style="position: relative;">
              <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popEmpContent"
                triggers="manual" #pe="ngbPopover" (click)="openPopover(pe);enterName('empType')" placement="bottom"
                popoverClass='dash-popover dashboard-popover'>
                <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
                  [placeholder]="!tenantSts? 'Tenant Status' : ''" readonly [(ngModel)]="tenantStatus">
                <label class="form-lable-dropdown">Tenant Status</label>
                <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
              </div>
            </div>

            <ng-template #popEmpContent>
              <div class="dashboard-popover">
                <div class="d-flex justify-content-between">
                  <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;">
                    <div class="row pb-2" *ngFor="let item of tenantStat;let index =i"
                      (click)="setTenantStatus(item); openPopover(pe);inputModelChange('tenantSts')"
                      style="justify-content: space-between;">
                      <div class="popover-content normal-font pl-3 email-width">
                        {{item.name}}
                      </div>
                      <div style="margin-right: 10px;" *ngIf="tenantStatus == item.name">
                        <img src="assets/images/company/tick.png">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="col-8"></div>
        </div>

        <div class="row">
          <div class="col-12"></div>
        </div>
      </div>

      <div class="row search-input">
        <div class="col-12"><img src="../../../../assets/images/search.png"><input type="text" name="searchText"
            id="searchText" placeholder="Type here to search…" [(ngModel)]="searchText"
            (keyup)="searchByText(searchText)" (search)="searchByText(searchText)"></div>
      </div>

      <div class="company-listing-layout">
        <div class="row pr-4">
          <div class="col-9 text pt-3">{{totalCount}} Companies</div>
          <div class="col-3 d-flex justify-content-end" *ngIf="companyAdd">
            <label class="check-container">
              <input type="checkbox" (click)="selectDeselectCompany()" [checked]="isChecked">
              <span class="checkmark" style="margin-top: 13px;"></span>
            </label>
            <p class="pl-3 pt-3 text-select">select all</p>
            <div class="list-option pl-4" *ngIf="selectedComp.length > 0"
              (click)="$event.stopPropagation();captureClick($event);openOptionDrawer = !openOptionDrawer">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div *ngIf="openOptionDrawer" class="drawer-container">
                <div>
                  <p (click)="changeCompanyStatus()" *ngIf="isActiveButton">De-activate company</p>
                  <p (click)="changeCompanyStatus()" *ngIf="isDeactiveButtton">Activate company</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="newCompanies && newCompanies.length > 0">
          <div class="mt-3" *ngFor='let item of getFilteredCompanies() | paginate: { itemsPerPage: pageSize,
            currentPage: page,
            totalItems: totalCount }'>
            <list [list]='item' [companylist]="true" (redirectToEditPage)="redirectToTenantEdit($event)"
              (updateCompany)="updateComp($event)" (selectedCheckBox)="getSelectedCompany($event)"
              [checked]="checkboxValue" (dotClicked)="dotDropDownDetail=$event;openOptionDrawer=false"
              [checkPopupFlag]="dotDropDownDetail"></list>
          </div>
        </ng-container>
      </div>

      <div class="d-flex justify-content-center pagination-section mt-4 mb-5">
        <div class="row d-flex pagination-border">
          <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
            class="d-flex justify-content-center">
          </pagination-controls>
          <div class="pr-3 ratio-class pt-1">
            {{page}}/{{displayCount}}</div>
        </div>
      </div>
    </div>